module.exports = __webpack_public_path__ + "assets/912f0dd13713bd25c9f1c1539b517bc7.mp4";